export default "__VITE_ASSET__L6uylT8t__"